import React, { useDeferredValue, useState } from "react";
import Pagination from "../../components/pagination";
import { TPatientDetails, TTableUser } from "../../types";
import { useGetPatients } from "../../apis/doctor";
import { useAppSelector } from "../../hooks/useAppSelector";
import { Flex, Text } from "@chakra-ui/react";
import NoItemsCard from "../patients/components/NoPatientsCard";
import { isFutureDay, isPastDay } from "../patients/utils";
import PatientsUtils from "./components/PatientsUtils";
import PatientsTable from "./components/PatientsTable";
import CreatePatientModal from "./components/CreatePatientModal";
import PatientDetailsModal from "./components/PatientDetailsModal";
import { useQueryClient } from "@tanstack/react-query";
import UpdatePatientModal from "./components/UpdatePatientModal";

const Patient = () => {
  //const [active, setActive] = useState("upcoming");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");

  const [isUpdatePatientModalOpen, setIsUpdatePatientModalOpen] =
    useState(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [user, setUser] = useState<TTableUser>({} as TTableUser);
  const { doctorInfo } = useAppSelector((state) => state.auth);

  const [selectedPatient, setSelectedPatient] = useState({} as TPatientDetails);

  const queryClient = useQueryClient();

  const cachedData: any = queryClient.getQueryData([
    "getPatients",
    doctorInfo?._id,
    limit,
    1,
    "",
    "",
  ]);

  const { data: patients, isLoading: patientsLoading } = useGetPatients({
    // doctorId: doctorInfo?._id,
    limit: 5,
    page: currentPage,
    search: useDeferredValue(search),
    riskCategory: category,
  });
  return (
    <>
      <div className="py-2 rounded-[7px] drop-shadow-lg bg-white">
        {patients?.data?.total === 0 ? (
          <Flex flex={1} h={"full"}>
            <NoItemsCard
              btnText="Add patient"
              handleBtnClick={() => setIsOpen(true)}
              subtitle="You do not have any patient yet"
              title="No patient"
            />
          </Flex>
        ) : (
          <>
            <PatientsUtils
              setSearch={setSearch}
              category={category}
              setCategory={setCategory}
              openModal={setIsOpen}
              setPage={setCurrentPage}
            />
            {patients?.data?.patients?.length === 0 ? (
              <Flex
                height={"100px"}
                width={"100%"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Text color={"red"} fontWeight={600}>
                  No patient matches the filter
                </Text>
              </Flex>
            ) : (
              <PatientsTable
                setIsDetailsModalOpen={setIsDetailsModalOpen}
                setIsUpdatePatientModalOpen={setIsUpdatePatientModalOpen}
                setSelectedPatient={setSelectedPatient}
                patients={patients?.data?.patients}
                loadingPatients={patientsLoading}
              />
            )}

            {/* {cachedData?.data?.total > limit && ( */}
            {patients?.data?.total > limit && (
              <div className="flex flex-1 justify-end mr-2">
                <Pagination
                  totalPages={patients?.data?.lastPage}
                  currentPage={currentPage}
                  onPageChange={setCurrentPage}
                />
              </div>
            )}
          </>
        )}
      </div>
      <CreatePatientModal
        isOpen={isOpen}
        onClose={setIsOpen}
        title="Create Patient"
      />

      <PatientDetailsModal
        isOpen={isDetailsModalOpen}
        onClose={setIsDetailsModalOpen}
        title="Patient's Details"
        patient={selectedPatient}
      />
      <UpdatePatientModal
        isOpen={isUpdatePatientModalOpen}
        onClose={setIsUpdatePatientModalOpen}
        patient={selectedPatient}
        title="Update Patient Info"
      />
    </>
  );
};

export default Patient;
